export default __webpack_public_path__ + "static/media/icon_endtype_OpenEnds.2d5bfc33.png";